import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const CreateNewStudentLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'CreateNewStudents' */ './compnents/CreateNewStudents'
		)
);

export default (store) => {
	return {
		path: 'students-setup/:campusId?/create-new-student',
		element: <AsyncLoading component={<CreateNewStudentLazy />} />,
	};
};
